export enum TaskResult {
    success = "success",
    fail = "fail"
}

export enum TaskResultLabel {
    success = "Başarılı",
    fail = "Başarısız"
}